const weekdays = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
];
const currentDay = new Date().getDay();
const lastWeekly = weekdays.slice(currentDay, 7 + currentDay);
lastWeekly[lastWeekly.length - 1] = 'Today';

export const bgChartProps = {
  options: {
    chart: {
      height: 142,
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        bottom: 2,
        left: 10,
        blur: 6,
        color: '#000',
        opacity: 0.35,
      },
      animations: {
        enabled: false,
      },
    },
    colors: ['#fff'],
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth' },
    tooltip: { enabled: false },
    grid: {
      padding: {
        bottom: -30,
        left: -10,
        right: 0,
        top: -30,
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      convertedCatToNumeric: true,
    },
    yaxis: { show: false },
  },
  series: [
    {
      name: 'Desktops',
      data: [18, 30, 25, 51, 34, 40, 34],
    },
  ],
  height: 142,
  type: 'line',
  id: 'sales-state-chart',
  width: '100%',
};

export const weeklyTransactionChartProps = {
  options: {
    chart: {
      id: 'bar-chart',
      stacked: false,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: false,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '60%',
      },
    },
    xaxis: {
      type: 'category',
      categories: lastWeekly,
    },
    legend: {
      show: true,
      fontSize: '14px',
      fontFamily: `'Roboto', sans-serif`,
      position: 'bottom',
      offsetX: 20,
      labels: {
        useSeriesColors: false,
      },
      markers: {
        width: 16,
        height: 16,
        radius: 5,
      },
      itemMargin: {
        horizontal: 15,
        vertical: 8,
      },
    },
    grid: {
      show: true,
    },
  },
  height: 500,
};

export const subMerchantRevenueChartProps = {
  series: [13, 35, 50, 40, 27, 49, 31],
  options: {
    chart: {
      id: 'donut-chart',
      type: 'donut',
    },
    labels: [
      'SubMerchant 01',
      'SubMerchant 02',
      'SubMerchant 03',
      'SubMerchant 04',
      'SubMerchant 05',
      'SubMerchant 06',
      'SubMerchant 07',
    ],
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          background: 'transparent',
        },
      },
    },
    stroke: {
      show: true,
      curve: 'smooth',
    },
  },
  type: 'donut',
  height: '500px',
};

export const transactionTypesChartProps = {
  series: [12, 35, 66],
  options: {
    chart: {
      id: 'donut-chart',
      type: 'donut',
    },
    legend: {
      position: 'bottom',
    },
    labels: ['Type 1', 'Type 2', 'Type 3'],
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          background: 'transparent',
        },
      },
    },
    stroke: {
      show: false,
    },
  },
  type: 'donut',
  height: '500px',
};